export default "__VITE_ASSET__bac9606c__"